export const validateStockItemFields = (filters) => {
  const fieldNames = [
    'item_price',
    'item_price_currency',
    'item_description'
  ]

  const fieldErrorMsgMapping = {
    'item_price': 'Item Price',
    'item_price_currency': 'Item Price Currency',
    'item_description': 'Item Description',
    'number_of_primary_diamonds_outstanding': 'Number of Primary Diamonds Outstanding'
  }

  let missingFields = fieldNames.filter((e) => { return !filters[e] })

  if (filters['primary_diamond_qty'] === '' || filters['primary_diamond_qty'] < 0) {
    missingFields.push('number_of_primary_diamonds_outstanding')
  }

  return missingFields.map((field) => {
    return fieldErrorMsgMapping[field]
  })
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/stock-item-fields/index.js